var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconShow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0787 19C6.73692 19 3.21616 13.607 2.2853 11.999C3.21318 10.389 6.72003 5 12.0787 5C17.4204 5 20.9412 10.393 21.872 12.001C20.9441 13.611 17.4363 19 12.0787 19ZM0.26166 12.447C0.435513 12.796 4.59704 21 12.0787 21C19.5603 21 23.7218 12.796 23.8947 12.447C24.0347 12.166 24.0347 11.834 23.8947 11.553C23.7218 11.204 19.5603 3 12.0787 3C4.59704 3 0.435513 11.204 0.26166 11.553C0.122578 11.834 0.122578 12.166 0.26166 12.447ZM10.0918 12C10.0918 10.897 10.9829 10 12.0787 10C13.1744 10 14.0655 10.897 14.0655 12C14.0655 13.103 13.1744 14 12.0787 14C10.9829 14 10.0918 13.103 10.0918 12ZM8.10489 12C8.10489 14.206 9.88713 16 12.0787 16C14.2702 16 16.0524 14.206 16.0524 12C16.0524 9.794 14.2702 8 12.0787 8C9.88713 8 8.10489 9.794 8.10489 12Z",
    fill: "#69B5B5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShow);
export default __webpack_public_path__ + "static/media/Icon-show.cccc05f905b28e99062a9ec06845a3ff.svg";
export { ForwardRef as ReactComponent };